import { instance } from '@/libs/api/instance.js'

/**
 * Get websocket token
 *
 * @return {Promise<AxiosResponse<{token: string, expiredAt: number, expiresIn: number}>>}
 */

export const getWsToken = async () => {
  return instance.post('/v3/auth/websocket')
}
